<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
      <div class="page-card-body" ref="pageRoot">
        <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
          <el-input v-model="keyword" placeholder="用户名/昵称/手机号" style="width:260px" clearable @keyup.enter.native="load" />
          <el-button type="primary" @click="openCreate">新增用户</el-button>
        </div>

        <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
          <el-table-column prop="username" label="用户名" width="140" />
          <el-table-column prop="nickName" label="昵称" width="160" />
          <el-table-column prop="phone" label="手机号" width="140" />
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="s">
              <el-tag :type="s.row.status===1?'success':'info'">{{ s.row.status===1?'启用':'停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="s">
              <el-button type="text" @click="openRoleAssign(s.row)">分配角色</el-button>
              <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
              <el-button type="text" @click="resetPwd(s.row)">重置密码</el-button>
              <el-button type="text" style="color:#ef4444" @click="remove(s.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div ref="pagerBar" class="pager-bar">
          <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="load"
          />
        </div>
      </div>
    </el-card>

    <el-dialog :title="form.id?'编辑用户':'新增用户'" :visible.sync="dlg" width="420px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="用户名">
          <el-input v-model="form.username" :disabled="!!form.id" />
        </el-form-item>
        <el-form-item label="昵称">
          <el-input v-model="form.nickName" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option :value="1" label="启用" />
            <el-option :value="0" label="停用" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!form.id" label="初始密码">
          <el-input v-model="form.password" type="password" placeholder="不填默认 123456" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="分配角色" :visible.sync="roleDlg" width="520px" destroy-on-close>
      <div v-loading="roleLoading">
        <div style="color:#64748b;font-size:12px;margin-bottom:12px;line-height:1.4;">
          用户：<b>{{ roleUser ? (roleUser.username + '（' + (roleUser.nickName || '-') + '）') : '-' }}</b>
          <span style="margin-left:8px;">保存后该用户重新登录即可看到最新菜单。</span>
        </div>

        <el-form label-width="80px">
          <el-form-item label="角色">
            <el-select v-model="selectedRoleIds" multiple filterable style="width:100%" placeholder="请选择角色">
              <el-option
                v-for="r in roleOptions"
                :key="r.id"
                :label="r.name + '（' + r.code + '）'"
                :value="r.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer">
        <el-button @click="roleDlg=false">取消</el-button>
        <el-button type="primary" :loading="roleSaving" @click="saveUserRoles">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'SysUser',
  mixins: [tableAutoHeight],
  data() {
    return {
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dlg: false,
      saving: false,
      form: { id: '', username: '', nickName: '', phone: '', status: 1, password: '' },

      roleDlg: false,
      roleLoading: false,
      roleSaving: false,
      roleUser: null,
      roleOptions: [],
      selectedRoleIds: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/sys/user/page', { params: { keyword: this.keyword, pageNum: this.pageNum, pageSize: this.pageSize } })
      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    openCreate() {
      this.form = { id: '', username: '', nickName: '', phone: '', status: 1, password: '' }
      this.dlg = true
    },
    openEdit(row) {
      this.form = { id: row.id, username: row.username, nickName: row.nickName, phone: row.phone, status: row.status }
      this.dlg = true
    },
    async save() {
      if (this.saving) return
      this.saving = true
      try {
        if (this.form.id) {
          await request.put('/admin/api/sys/user/' + this.form.id, this.form)
        } else {
          await request.post('/admin/api/sys/user', this.form)
        }
        this.$message.success('已保存')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    },
    async resetPwd(row) {
      const { value } = await this.$prompt('输入新密码（不填默认 123456）', '重置密码', { inputType: 'password', confirmButtonText: '确定', cancelButtonText: '取消' }).catch(() => ({ value: null }))
      if (value === null) return
      await request.post('/admin/api/sys/user/' + row.id + '/resetPassword', { password: value })
      this.$message.success('已重置')
    },
    async remove(row) {
      await this.$confirm('确认删除该用户？', '提示', { type: 'warning' })
      await request.delete('/admin/api/sys/user/' + row.id)
      this.$message.success('已删除')
      await this.load()
    },

    async openRoleAssign(user) {
      this.roleUser = user
      this.roleDlg = true
      this.roleLoading = true
      try {
        const [roles, res] = await Promise.all([
          request.get('/admin/api/sys/role/list'),
          request.get('/admin/api/sys/user/' + user.id + '/roles')
        ])
        this.roleOptions = Array.isArray(roles) ? roles : []
        this.selectedRoleIds = res && Array.isArray(res.roleIds) ? res.roleIds : []
      } finally {
        this.roleLoading = false
      }
    },
    async saveUserRoles() {
      if (this.roleSaving) return
      if (!this.roleUser) return

      this.roleSaving = true
      try {
        await request.put('/admin/api/sys/user/' + this.roleUser.id + '/roles', { roleIds: this.selectedRoleIds || [] })
        this.$message.success('已保存')
        this.roleDlg = false
      } finally {
        this.roleSaving = false
      }
    }
  }
}
</script>
